<template>
  <div class="row">
    <div class="is-desktop">
      <div>
        <div v-for="subject in subjects" :key="subject">
          {{ subject }}
        </div>
      </div>
      <div>{{ record.description }}</div>
      <div>
        <div v-for="date in record.class_time" :key="date">
          {{ date }}
        </div>
      </div>
      <div v-html="statusData(record.status)"></div>
    </div>
    <div class="is-mobile">
      <div>
        <div>{{ record.description }}</div>
        <div v-for="date in record.class_time" :key="date">
          {{ date }}
        </div>
      </div>
      <div v-html="statusData(record.status)"></div>
    </div>
  </div>
</template>

<script>
import { getSubjectName } from "@/utils/subjects.js";

export default {
  props: {
    record: {
      id: Number,
      grade: Number,
      location: String,
      level: String,
      subjects: Array,
      description: String,
      class_time: Array,
      status: String
    }
  },
  computed: {
    subjects() {
      return this.record.subjects.map(getSubjectName);
    }
  },
  methods: {
    statusData(text) {
      return text.replace(/\n/g, "<br>");
    }
  }
};
</script>

<style lang="scss" scoped>
.is-desktop {
  display: grid;
  grid-template-columns: 1fr 3fr 3fr 2fr;
  color: #6b6b6b;
  font-size: 16px;
  line-height: 1.5rem;
  font-weight: bold;

  > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

.is-mobile {
  display: none;
  grid-template-columns: 4fr 3fr;
  color: #6b6b6b;
  font-size: 16px;
  line-height: 1.5rem;
  font-weight: bold;

  > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .is-desktop {
    display: none;
    grid-template-columns: 2fr 5fr 6fr 3fr !important;
    > div {
      border-left: 1px solid #e4e4e4;
      padding: 2px 5px;
      &:first-child {
        border-left: none;
      }
    }
  }

  .is-mobile {
    display: grid;
    grid-template-columns: 4fr 3fr !important;
    > div {
      border-left: 1px solid #e4e4e4;
      padding: 8px 5px;
      &:first-child {
        border-left: none;
      }
    }
  }
}
</style>
